/**
 * 10Duke End User Identity API
 * Authenticate user and manage authenticated sessions
 *
 * OpenAPI spec version: 2.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddAuthenticationsResult } from '../model/addAuthenticationsResult';
import { AgreementAcceptance } from '../model/agreementAcceptance';
import { ApiError } from '../model/apiError';
import { AuthenticationChallenges } from '../model/authenticationChallenges';
import { TimeBasedOneTimePasswordCredential } from '../model/timeBasedOneTimePasswordCredential';
import { UserCodeForDeviceAuthorization } from '../model/userCodeForDeviceAuthorization';
import { UserCodeForDeviceAuthorizationDecisionRequired } from '../model/userCodeForDeviceAuthorizationDecisionRequired';
import { UserNameAndPasswordCredential } from '../model/userNameAndPasswordCredential';
import { UserNameAndPasswordCredentialForResetPassword } from '../model/userNameAndPasswordCredentialForResetPassword';
import { UserNameAndPasswordCredentialForSetLoginEmail } from '../model/userNameAndPasswordCredentialForSetLoginEmail';
import { VerifyLoginEmailCredential } from '../model/verifyLoginEmailCredential';
import { VerifyRecoveryEmailCredential } from '../model/verifyRecoveryEmailCredential';
import { WebAuthnPublicKeyCredential } from '../model/webAuthnPublicKeyCredential';
import { WebAuthnPublicKeyCredentialForActivateUser } from '../model/webAuthnPublicKeyCredentialForActivateUser';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AuthenticationService {

    protected basePath = 'http://localhost:8080/api/v2';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Adds user authentications, or executes operation that requires giving authentication credentials
     * Adds one or more user authentications, for instance user name and password authentication, and a second factor authentication with a time-based one-time password. Also used for any operation that requires specifying authentication credentials, allowing similar security measures for protecting the credentials. Both successful and failed request may return authentication challenges as \&quot;WWW-Authenticate\&quot; header values if the user has not fully completed authentication. In this case, each header desribes an authentication flow available to the user, and user must complete one of the authentication flows.
     * @param body Array of authentication credentials. At least one credential object must by supplied.
     * @param remember Indicates if authenticated session created by the operation should be created as a persistent session
     * @param returnUser Instructs server to return data of the authenticated user in the response
     * @param returnAuthentications Instructs server to return data of completed authentications in the response
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addAuthentications(body: Array<UserNameAndPasswordCredential | TimeBasedOneTimePasswordCredential | VerifyLoginEmailCredential | VerifyRecoveryEmailCredential | UserNameAndPasswordCredentialForResetPassword | UserNameAndPasswordCredentialForSetLoginEmail | AgreementAcceptance | UserCodeForDeviceAuthorization | WebAuthnPublicKeyCredential | WebAuthnPublicKeyCredentialForActivateUser>, remember?: boolean, returnUser?: boolean, returnAuthentications?: boolean, observe?: 'body', reportProgress?: boolean): Observable<AddAuthenticationsResult>;
    public addAuthentications(body: Array<UserNameAndPasswordCredential | TimeBasedOneTimePasswordCredential | VerifyLoginEmailCredential | VerifyRecoveryEmailCredential | UserNameAndPasswordCredentialForResetPassword | UserNameAndPasswordCredentialForSetLoginEmail | AgreementAcceptance | UserCodeForDeviceAuthorization | WebAuthnPublicKeyCredential | WebAuthnPublicKeyCredentialForActivateUser>, remember?: boolean, returnUser?: boolean, returnAuthentications?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddAuthenticationsResult>>;
    public addAuthentications(body: Array<UserNameAndPasswordCredential | TimeBasedOneTimePasswordCredential | VerifyLoginEmailCredential | VerifyRecoveryEmailCredential | UserNameAndPasswordCredentialForResetPassword | UserNameAndPasswordCredentialForSetLoginEmail | AgreementAcceptance | UserCodeForDeviceAuthorization | WebAuthnPublicKeyCredential | WebAuthnPublicKeyCredentialForActivateUser>, remember?: boolean, returnUser?: boolean, returnAuthentications?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddAuthenticationsResult>>;
    public addAuthentications(body: Array<UserNameAndPasswordCredential | TimeBasedOneTimePasswordCredential | VerifyLoginEmailCredential | VerifyRecoveryEmailCredential | UserNameAndPasswordCredentialForResetPassword | UserNameAndPasswordCredentialForSetLoginEmail | AgreementAcceptance | UserCodeForDeviceAuthorization | WebAuthnPublicKeyCredential | WebAuthnPublicKeyCredentialForActivateUser>, remember?: boolean, returnUser?: boolean, returnAuthentications?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addAuthentications.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (remember !== undefined && remember !== null) {
            queryParameters = queryParameters.set('remember', <any>remember);
        }
        if (returnUser !== undefined && returnUser !== null) {
            queryParameters = queryParameters.set('returnUser', <any>returnUser);
        }
        if (returnAuthentications !== undefined && returnAuthentications !== null) {
            queryParameters = queryParameters.set('returnAuthentications', <any>returnAuthentications);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AddAuthenticationsResult>('post',`${this.basePath}/sessions/authentications`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets information of existing user authentications
     * Returns authentication challenge objects representing challenges responded by the session user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listAuthentications(observe?: 'body', reportProgress?: boolean): Observable<AuthenticationChallenges>;
    public listAuthentications(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AuthenticationChallenges>>;
    public listAuthentications(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AuthenticationChallenges>>;
    public listAuthentications(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AuthenticationChallenges>('get',`${this.basePath}/sessions/authentications`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
